// extracted by mini-css-extract-plugin
module.exports = {"root":"breadcrumbs_root__T9xbr","item":"breadcrumbs_item__gSexM","separator":"breadcrumbs_separator__zeH1f","active":"breadcrumbs_active__AwES7"};